import React, { useState } from 'react';
import { Form, Button, Row, Col, Card } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { createFacilityBuildingRoom } from '../../../../services/FacilityBuildingRoomService';

const AddFacilityBuildingRoom = () => {
  const [label, setLabel] = useState('');
  const [value, setValue] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await createFacilityBuildingRoom({ label, value });
      navigate('/settings/fbr/');
    } catch (error) {
      console.error('Error adding facility building room', error);
    }
  };

  return (
    <div>
      <Card>
      <h2>Add Facility Building Room</h2>
      <Form onSubmit={handleSubmit}>
        <Row>
          <Col>
        <Form.Group controlId="label">
          <Form.Label>Label</Form.Label>
          <Form.Control
            type="text"
            value={label}
            onChange={(e) => setLabel(e.target.value)}
          />
        </Form.Group>
        </Col>
        <Col>
        <Form.Group controlId="value">
          <Form.Label>Value</Form.Label>
          <Form.Control
            type="text"
            value={value}
            onChange={(e) => setValue(e.target.value)}
          />
        </Form.Group>
        </Col>
        </Row>
        <div className="d-flex justify-content-end m-2 " >
        <Button  type="submit">
          Add Room
        </Button>
        </div>
      </Form>
      </Card>
    </div>
  );
};

export default AddFacilityBuildingRoom;
